<div>
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <mat-icon>home_work</mat-icon>
        Alquileres por Propietario - Mes a Mes
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="form">
        <div class="row">
          <div class="col-lg-6">
            <app-buscar-persona-propietaria (eventEntity)="selectPropietario($event)"></app-buscar-persona-propietaria>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-2">
            <mat-form-field class="example-full-width">
              <mat-icon matPrefix>date_range</mat-icon>
              <mat-label>Mes Desde</mat-label>
              <mat-select formControlName="PeriodoMesDesde">
                <mat-option [value]="1">Enero</mat-option>
                <mat-option [value]="2">Febrero</mat-option>
                <mat-option [value]="3">Marzo</mat-option>
                <mat-option [value]="4">Abril</mat-option>
                <mat-option [value]="5">Mayo</mat-option>
                <mat-option [value]="6">Junio</mat-option>
                <mat-option [value]="7">Julio</mat-option>
                <mat-option [value]="8">Agosto</mat-option>
                <mat-option [value]="9">Septiembre</mat-option>
                <mat-option [value]="10">Octubre</mat-option>
                <mat-option [value]="11">Noviembre</mat-option>
                <mat-option [value]="12">Diciembre</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-2">
            <mat-form-field class="example-full-width">
              <mat-icon matPrefix>event</mat-icon>
              <mat-label>Año Desde</mat-label>
              <input type="number" matInput formControlName="PeriodoAnioDesde" [min]="2020" [max]="2035">
            </mat-form-field>
          </div>
          <div class="col-lg-2">
            <mat-form-field class="example-full-width">
              <mat-icon matPrefix>date_range</mat-icon>
              <mat-label>Mes Hasta</mat-label>
              <mat-select formControlName="PeriodoMesHasta">
                <mat-option [value]="1">Enero</mat-option>
                <mat-option [value]="2">Febrero</mat-option>
                <mat-option [value]="3">Marzo</mat-option>
                <mat-option [value]="4">Abril</mat-option>
                <mat-option [value]="5">Mayo</mat-option>
                <mat-option [value]="6">Junio</mat-option>
                <mat-option [value]="7">Julio</mat-option>
                <mat-option [value]="8">Agosto</mat-option>
                <mat-option [value]="9">Septiembre</mat-option>
                <mat-option [value]="10">Octubre</mat-option>
                <mat-option [value]="11">Noviembre</mat-option>
                <mat-option [value]="12">Diciembre</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-2">
            <mat-form-field class="example-full-width">
              <mat-icon matPrefix>event</mat-icon>
              <mat-label>Año Hasta</mat-label>
              <input type="number" matInput formControlName="PeriodoAnioHasta" [min]="2020" [max]="2035">
            </mat-form-field>
          </div>
          <div class="col-lg-2">
            <mat-form-field class="example-full-width">
              <ngx-spinner [zIndex]="100" name="spBusquedaTipoAjusteContrato" bdColor="rgba(255,255,255,0.8)"
                size="small" color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
              <mat-label>Tipos de Ajuste</mat-label>
              <mat-select placeholder="Seleccione opcion" multiple formControlName="TiposAjusteContrato">
                <mat-option [value]="tipoAjusteContrato.id"
                  *ngFor="let tipoAjusteContrato of lstTiposAjusteContrato;let i=index;trackBy:trackByItems"
                  [matTooltip]="tipoAjusteContrato.descripcion">
                  {{ tipoAjusteContrato.acronimo | uppercase }}</mat-option>
              </mat-select>
              <mat-error *ngIf="f.TiposAjusteContrato.errors?.required">Este campo es
                <strong>requerido</strong>.</mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-2">
            <mat-form-field class="example-full-width">
              <ngx-spinner [zIndex]="100" name="spBusquedaEstadosContrato" bdColor="rgba(255,255,255,0.8)" size="small"
                color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
              <mat-label>Estados de Contrato</mat-label>
              <mat-select placeholder="Seleccione opcion" multiple formControlName="EstadosContrato">
                <mat-option [value]="estadoContrato.id"
                  *ngFor="let estadoContrato of lstEstadosContrato;let i=index;trackBy:trackByItems"
                  [matTooltip]="estadoContrato.descripcion">
                  {{ estadoContrato.descripcion | titlecase }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="checkedFiltroAvanzado">
          <div class="col-lg-3" *ngIf="checkedFiltroAvanzado">
            <mat-form-field class="full-width">
              <mat-label>Fecha Vencimiento</mat-label>
              <mat-date-range-input [rangePicker]="pickerFechaVencimiento">
                <input matStartDate [disabled]="true" formControlName="FechaVencimientoDesde" appDateFormat="DD/MM/YYYY"
                  placeholder="Fecha desde" />
                <input matEndDate [disabled]="true" appDateFormat="DD/MM/YYYY" formControlName="FechaVencimientoHasta"
                  placeholder="Fecha hasta" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerFechaVencimiento"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerFechaVencimiento></mat-date-range-picker>
            </mat-form-field>
          </div>
          <div class="col-lg-3" *ngIf="checkedFiltroAvanzado">
            <mat-form-field class="full-width">
              <mat-label>Fechas de Ajuste</mat-label>
              <mat-date-range-input [rangePicker]="pickerFechaAjuste">
                <input matStartDate [disabled]="true" appDateFormat="DD/MM/YYYY" formControlName="FechaAjusteDesde"
                  placeholder="Fecha desde" />
                <input matEndDate [disabled]="true" appDateFormat="DD/MM/YYYY" formControlName="FechaAjusteHasta"
                  placeholder="Fecha hasta" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerFechaAjuste"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerFechaAjuste></mat-date-range-picker>
            </mat-form-field>
          </div>
          <div class="col-lg-3" *ngIf="checkedFiltroAvanzado">
            <mat-form-field class="full-width">
              <mat-label>Fechas de Liquidación</mat-label>
              <mat-date-range-input [rangePicker]="pickerFechaLiquidacion">
                <input matStartDate [disabled]="true" appDateFormat="DD/MM/YYYY" formControlName="FechaLiquidacionDesde"
                  placeholder="Fecha desde" />
                <input matEndDate [disabled]="true" appDateFormat="DD/MM/YYYY" formControlName="FechaLiquidacionHasta"
                  placeholder="Fecha hasta" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerFechaLiquidacion"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerFechaLiquidacion></mat-date-range-picker>
            </mat-form-field>
          </div>
          <div class="col-lg-3" *ngIf="checkedFiltroAvanzado">
            <mat-form-field class="full-width">
              <mat-label>Fechas de Pago</mat-label>
              <mat-date-range-input [rangePicker]="pickerFechaPago">
                <input matStartDate [disabled]="true" appDateFormat="DD/MM/YYYY" formControlName="FechaPagoDesde"
                  placeholder="Fecha desde" />
                <input matEndDate [disabled]="true" appDateFormat="DD/MM/YYYY" formControlName="FechaPagoHasta"
                  placeholder="Fecha hasta" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerFechaPago"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerFechaPago></mat-date-range-picker>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <button mat-stroked-button color="primary" [disabled]="!form.valid" (click)="filtrar()">
              <mat-icon>filter_alt</mat-icon>
              Filtrar</button>&nbsp; &nbsp;
            <mat-slide-toggle class="example-margin" [checked]="checkedFiltroAvanzado"
              (change)="filtrosAvanzados($event)" color="primary">
              Filtros Avanzados
            </mat-slide-toggle>&nbsp; &nbsp;
            <button mat-stroked-button color="primary" (click)="limpiar()">
              <mat-icon>clear_all</mat-icon>
              Limpiar</button>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card class="mt-3">
    <ngx-spinner [zIndex]=100 bdColor="rgba(255,255,255,0.8)" size="default" color="#009688" type="ball-atom"
      [fullScreen]="false">
    </ngx-spinner>

    <div *ngIf="data">
      <mat-accordion multi="true">
        <mat-expansion-panel *ngFor="let grupo of grupos">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>apartment</mat-icon>&nbsp;
              {{ grupo.direccionPropiedad | titlecase }} — Contrato N° {{ grupo.numeroContrato }}
            </mat-panel-title>
            <mat-panel-description>
              Total bruto: {{ grupo.totalBruto | currency }} — Total neto (estimado): {{ grupo.totalNeto | currency }}
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="row" style="margin-bottom: 8px;">
            <div class="col-lg-4"><mat-icon style="vertical-align: middle;">person</mat-icon> Inquilino: {{
              grupo.inquilino }}</div>
            <div class="col-lg-4"><mat-icon style="vertical-align: middle;">event</mat-icon> Vto. Contrato: {{
              grupo.fechaVencimientoContrato | date:"dd/MM/yyyy" }}</div>
          </div>

          <table mat-table [dataSource]="grupo.periodos" class="mat-elevation-z0" style="width: 100%;">
            <ng-container matColumnDef="periodo">
              <th mat-header-cell *matHeaderCellDef (click)="ordenarGrupo(grupo, 'periodo')" class="sortable-header">
                Período
                <mat-icon *ngIf="grupo.sortField === 'periodo'" class="sort-icon">
                  {{ grupo.sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </th>
              <td mat-cell *matCellDef="let p"> {{ p.periodo }} </td>
            </ng-container>

            <ng-container matColumnDef="fechaVencimiento">
              <th mat-header-cell *matHeaderCellDef (click)="ordenarGrupo(grupo, 'fechaVencimiento')"
                class="sortable-header">
                Fecha Vto.
                <mat-icon *ngIf="grupo.sortField === 'fechaVencimiento'" class="sort-icon">
                  {{ grupo.sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </th>
              <td mat-cell *matCellDef="let p"> {{ p.fechaVencimiento | date:"dd/MM/yyyy" }} </td>
            </ng-container>

            <ng-container matColumnDef="fechaPago">
              <th mat-header-cell *matHeaderCellDef (click)="ordenarGrupo(grupo, 'fechaPago')" class="sortable-header">
                Fecha Pago
                <mat-icon *ngIf="grupo.sortField === 'fechaPago'" class="sort-icon">
                  {{ grupo.sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </th>
              <td mat-cell *matCellDef="let p"> {{ p.fechaPago | date:"dd/MM/yyyy" }} </td>
            </ng-container>

            <ng-container matColumnDef="fechaLiquidacion">
              <th mat-header-cell *matHeaderCellDef (click)="ordenarGrupo(grupo, 'fechaLiquidacion')"
                class="sortable-header">
                Fecha Liquidación
                <mat-icon *ngIf="grupo.sortField === 'fechaLiquidacion'" class="sort-icon">
                  {{ grupo.sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </th>
              <td mat-cell *matCellDef="let p"> {{ p.fechaLiquidacion | date:"dd/MM/yyyy" }} </td>
            </ng-container>

            <ng-container matColumnDef="importeAlquiler">
              <th mat-header-cell *matHeaderCellDef (click)="ordenarGrupo(grupo, 'importeAlquiler')"
                class="sortable-header">
                Importe Bruto
                <mat-icon *ngIf="grupo.sortField === 'importeAlquiler'" class="sort-icon">
                  {{ grupo.sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </th>
              <td mat-cell *matCellDef="let p"> {{ p.importeAlquiler | currency }} </td>
            </ng-container>

            <ng-container matColumnDef="importeNeto">
              <th mat-header-cell *matHeaderCellDef (click)="ordenarGrupo(grupo, 'importeNeto')"
                class="sortable-header">
                Importe Neto (estimado)
                <mat-icon *ngIf="grupo.sortField === 'importeNeto'" class="sort-icon">
                  {{ grupo.sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </th>
              <td mat-cell *matCellDef="let p"> {{ p.importeNetoEstimado | currency }} </td>
            </ng-container>

            <tr mat-header-row
              *matHeaderRowDef="['periodo','fechaVencimiento','fechaPago','fechaLiquidacion','importeAlquiler','importeNeto']">
            </tr>
            <tr mat-row
              *matRowDef="let row; columns: ['periodo','fechaVencimiento','fechaPago','fechaLiquidacion','importeAlquiler','importeNeto'];">
            </tr>
          </table>
        </mat-expansion-panel>
      </mat-accordion>

      <div class="row" style="margin-top: 16px; font-weight: bold;">
        <div class="col">
          Total general bruto: {{ totalGeneralBruto | currency }} — Total general neto (estimado): {{ totalGeneralNeto |
          currency }}
        </div>
      </div>
    </div>

    <div class="no-data-table" [hidden]="data">
      <span class="with-icon">
        <mat-icon>search_off</mat-icon> Seleccioná un propietario y filtrá para ver el detalle.
      </span>
    </div>
  </mat-card>
</div>
